import React, { useEffect, useState } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Card } from "@mui/material";
import GridTable from "cvmgmt-cube-grid-table";
import { useLocation } from "react-router-dom";
import { GridTableDataType } from "cvmgmt-cube-grid-table/dist/types/src/GridTable/types";
import * as styles from "./FeaturesNPermissions.module.scss";
import {
  LoadingSpinner,
  Pagination,
  StructuredList,
} from "cprime-foundational-components";
import { fetchAPIResponse } from "../../../services/APIHandler/APIHandler";
import CustomBreadcrumb from "../../../Components/CustomBreadcrumb/CustomBreadcrumb";
import { useIdToken } from "../../../hooks/useAuthSession";

const FeaturesNPermissions: React.FC = () => {
  const location = useLocation();
  const { userId, roleId, workdayID, role, accessStatus, userName } =
    location?.state || {
      userId: null,
      roleId: null,
      workdayID: null,
      role: "-",
      accessStatus: "-",
      userName: "-",
    };
  const scssClass = styles as any;
  const [featuresData, setFeaturesData] = useState<GridTableDataType | any>([]);
  const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 25 });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const idToken = useIdToken();

  const fetchData = async () => {
    setIsLoading(true);
    const resp = await fetchAPIResponse(
      {
        sortingFilter: {
          filter: [],
          sort: [],
          columns: [],
          page: {
            limit: pagination.rowsPerPage,
            //offset: pagination.page,
            offset: pagination?.page * pagination?.rowsPerPage,
          },
        },
      },
      `/user/feature-permission?role_id=${roleId}&user_id=${userId}`,
    );
    resp.columns = resp?.columns?.map((column: any) => {
      return {
        ...column,
        size: column?.size ?? 200,
        minSize: column?.minSize ?? 200,
      };
    });
    setFeaturesData(resp);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [pagination]);

  return (
    <div className={scssClass.mainContainer}>
      <CustomBreadcrumb
        items={[
          {
            label: "User Access",
            href: "/user-access",
            icon: <HomeOutlinedIcon sx={{ color: "#2469FF" }} />,
          },
          {
            label: `${workdayID}`,
            href: `/user-access/${workdayID}`,
          },
          {
            label: `Features and Permissions`,
            href: undefined,
          },
        ]}
      />
      <Card className={scssClass?.cardContainer}>
        <div className={scssClass?.cardHeading}>{userName ?? "-"}</div>
        <div className={scssClass?.cardSubHeadeading}>
          <span className={scssClass?.contents}>Role: {role ?? "-"}</span>
          <ul className={scssClass?.listItem}>
            <li className={scssClass?.contents}>
              Access Status:{" "}
              <span className={scssClass?.status}>{accessStatus ?? "-"}</span>
            </li>
          </ul>
        </div>
      </Card>
      {idToken !== null && isLoading ? (
        <LoadingSpinner fullScreen={true} />
      ) : (
        <>
          {/* <Card className={scssClass.requestedFeatureCard}>
            <div className={scssClass.requestedFeatureHeading}>
              Features Requested
            </div>
            {featuresData?.requested_features?.rows?.length > 0 ? (
              <StructuredList
                columns={featuresData?.requested_features?.columns ?? []}
                className={scssClass.tableBackground}
                rows={featuresData?.requested_features?.rows ?? []}
              />
            ) : (
              <div className="MuiBox-root css-1pohhbi">
                <div className="MuiBox-root css-d4kl2j">
                  <div className={scssClass.structuredListNoDataContainer}>
                    <img
                      src="data:image/svg+xml,%3csvg%20width='81'%20height='75'%20viewBox='0%200%2081%2075'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M48.5%2037.3325V74.6675L16.5%2056V18.6675L48.5%2037.3325Z'%20fill='%23C6C6C6'/%3e%3cpath%20d='M48.5%2037.335V74.6675L80.5%2056V18.6675L48.5%2037.335Z'%20fill='%23E0E0E0'/%3e%3cpath%20d='M48.5%200L16.5%2018.6675L48.5%2037.335L80.5%2018.6675L48.5%200Z'%20fill='%23F4F4F4'/%3e%3cpath%20d='M40.5%2042L24.5%2032.6675L24.535%2051.355L40.5%2060.6675V42Z'%20fill='%23262626'/%3e%3cpath%20d='M24.5349%2051.355L40.4999%2042V60.6675L24.5349%2051.355Z'%20fill='%23393939'/%3e%3cpath%20d='M12.495%2044.33L0.5%2051.3275L12.495%2058.325L24.49%2051.3275L12.495%2044.33Z'%20fill='%23FA4D56'/%3e%3cpath%20d='M24.4901%2051.3275V65.3225L12.4951%2072.32V58.325L24.4901%2051.3275Z'%20fill='%23C40818'/%3e%3cpath%20d='M12.495%2058.325L0.5%2051.3275L0.5275%2065.3375L12.495%2072.32V58.325Z'%20fill='%23EB0A1E'/%3e%3c/svg%3e"
                      alt="group"
                      className={scssClass.noDataImg}
                    />
                    <p className={scssClass.noDataFoundText}>No Data Found</p>
                  </div>
                </div>
              </div>
            )}
          </Card> */}
          <>
            <GridTable
              title={"Approved Features"}
              style={{
                height: "calc(100vh - 28rem)",
                overflow: "auto",
                minHeight: "6.875rem",
              }}
              customPayload={true}
              isCustomizeColumns={false}
              isPagination={true}
              isFiltering={false}
              isSorting={false}
              data={featuresData?.approved_features}
              showLoader={false}
              loading={isLoading}
            />
            <Pagination
              sx={{ width: "100%" }}
              {...{
                ...pagination,
                count: featuresData?.approved_features?.totalCount ?? 0,
                rowsPerPageOptions: [25, 50, 100, 250],
                onPageChange: (e, number) => {
                  setPagination({ ...pagination, page: number });
                },
                onRowsPerPageChange: (evt) => {
                  setPagination({
                    page: 0,
                    rowsPerPage: Number(evt.target.value),
                  });
                },
              }}
            />
          </>
        </>
      )}
    </div>
  );
};

export default FeaturesNPermissions;
